module.exports = __webpack_public_path__ + "img/icon-briefcase.b51dc03b.svg";